// imageData.js
// import side_slider_1 from '../../assets/images/side_slider_1.jpg';
// import side_slider_2 from '../../assets/images/basketball_banner_7.jpg';
// import football_side_slider_1 from '../../assets/images/football_side_slider_1.jpg';
//  import football_side_slider_2 from '../../assets/images/football_side_slider_2.jpg';
//  import fb_6 from '../../assets/images/georgia6.webp';
//  import fb_8 from '../../assets/images/georgia8.webp';
 
// import creighton_2 from '../../assets/images/creighton_2.webp'
// import creighton_4 from '../../assets/images/creighton_4.jpg'
import dc_11 from '../../assets/images/davidson11.webp';
import dc_12 from '../../assets/images/davidson12.webp';


export const sliderImages = [
  {
    id: 1,
    url: dc_11
  },
  {
    id: 2,
    url: dc_12
  },
];
